export function renewingAuthToken(state = false, action) {
  switch (action.type) {
    case 'REFRESH_TOKEN_REQUEST':
      return true;
    case 'REFRESH_TOKEN_DONE':
      return false;
    default:
      return state;
  }
}
